import React from 'react';
export default class MinimalResumeEducation extends React.Component{

    getResumeBlock(data, index){
        let title = [];
        if (data.degree){
            title.push(<span key="a" data-v-b8233322="">{data.degree}</span>)
        }

        if (data.schoolName){
            title.push(<span key="b" data-v-b8233322="">{data.schoolName}</span>)
        }

        let titleFinal = [];
        for(let i = 0; i < title.length; i++){
            titleFinal.push(title[i]);
            if(i + 1 < title.length){
                titleFinal.push(<span key={i} data-v-b8233322="" className="comma">, </span>)
            }
        }

        return  <div data-v-b8233322="" className="section-item" key={index}>
                    {data.endDate && data.startDate &&
                    <div data-v-b8233322="" className="section-date">
                        <span data-v-b8233322="">{data.startDate} -</span>
                        <span data-v-b8233322="">{data.endDate}</span>
                    </div>}
                    <div data-v-b8233322="" className="section-title">
                        {titleFinal}
                    </div>
                    <div data-v-b8233322="" className="section-description" dangerouslySetInnerHTML={{ __html: data.description }}></div>
                </div>
    }

    render(){
        return  <div data-v-b8233322="" className="section">
                    <div data-v-b8233322="" className="section-headline">{this.props.title}</div>
                    {this.props.data.map((item, index) => {
                        return this.getResumeBlock(item, index);
                    })}
                </div>

    }
}